export default {
    INITIAL: 0,
    LOST: 1,
    WON: 2,
}